import { FC } from "react";
import { Files } from "./files";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { useMutation, useQuery } from "@apollo/client";
import { CasesSendReportV1FilesContainerSendReportCaseV1Document, CasesSendReportV1FilesContainerSendReportCaseV1UpdateDocument } from "../../../../../../generated";
import { AzureBlobResponse } from "../../../../../shared/file-upload/azure-upload";
import { message } from "antd";
import { useParams } from "react-router-dom";

interface FilesContainerProps {
  caseId: string | undefined;
  isCaseOrApplicant: string;
}

export const FilesContainer: FC<FilesContainerProps>  = (props) => {
    const params = useParams();

  const {
    data: caseData,
    loading,
    error,
  } = useQuery(CasesSendReportV1FilesContainerSendReportCaseV1Document, {
    variables: {
      sendReportCaseV1Id: params.caseId,
    },
  });
  
  const [updatedIdentityVerificationCaseV1] = useMutation(
    CasesSendReportV1FilesContainerSendReportCaseV1UpdateDocument
  );

  const handleOnUploadSuccess = async (response: AzureBlobResponse, fieldName: string) => {
    const input = {
      id: props.caseId,
      assets:{
        private: {
          [fieldName]: response.blobUrl,
          [`${fieldName}Version`]: response.versionId,
        }
      }
    };
    updatedIdentityVerificationCaseV1({
      variables: {
        input,
      },
    }).then((res) => {
      if (res.data?.sendReportCaseV1Update?.status?.success) {
        message.success("File uploaded successfully");
      } else {
        message.error("Failed to upload file: " + res.data?.sendReportCaseV1Update?.status.errorMessage);
      }
    });
  }

  return (
   <ComponentQueryLoader
   loading={loading}
   error={error}
   hasData={caseData}
   hasDataComponent={
    <Files
      shared={true}
      caseId={params.caseId ?? ""}
      onUploadSuccess={(response, fieldname) =>
        handleOnUploadSuccess(response, fieldname)
      }
      caseState={caseData?.sendReportCaseV1?.state ?? ""}
      isAssigned={caseData?.sendReportCaseV1?.isCurrentUserAssigned ?? false}
      isCaseOrApplicant={props.isCaseOrApplicant}
    />
   }
      />
  );
};
